import React from 'react'
import { useNavigate } from "react-router-dom"

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation"

import Car1 from "../../../../Assets/car11.png"
import Car2 from "../../../../Assets/car22.png"
import Car3 from "../../../../Assets/car33.png"
// import Car4 from "../../../../Assets/car4.webp"
// import Car5 from "../../../../Assets/car5.webp"

import { useSelector } from 'react-redux';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import "./CarsSlider.scss"

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1
    }
};

const CarsSlider = () => {
    const Navigate = useNavigate()

    let carsData = useSelector((state) => state.CarsData)

    return (
        <>
            <div className="carslider_container">
                <Swiper
                    loop={true}
                    direction={"vertical"}
                    pagination={{
                        clickable: true,
                    }}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay, Pagination]}
                    className="mySwiper"
                >
                    {/* <Swiper
                    slidesPerView={3}
                    spaceBetween={30}
                    slidesPerGroup={1}
                    loop={true}
                    loopFillGroupWithBlank={true}
                    pagination={{
                        clickable: true
                    }}
                    navigation={true}
                    modules={[Pagination, Navigation]}
                    className="mySwiper"
                > */}
                    {
                        carsData && carsData.length >= 1 ?
                            carsData.map((data) => {
                                return (
                                    <>
                                        <SwiperSlide>
                                            <div className="slider_box">
                                                <div className="title_box">
                                                    <div className="new">Now Delivering</div>
                                                    <div className="name">{data.name}</div>
                                                </div>
                                                <div className="img_box">
                                                    <img src={data.paintsWheels[0].wheels[0].carImg} alt="" />
                                                </div>
                                                <div className="btn_box">
                                                    <div className="design" onClick={() => Navigate(`/design?id=${data._id}`)}>Design yours</div>
                                                    {/* <div className="model">Compare Model</div> */}
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    </>
                                )
                            })
                            :
                            <>
                                <SwiperSlide>
                                    <div className="slider_box">
                                        <div className="title_box">
                                            <div className="new">Now Delivering</div>
                                            <div className="name">Flux Village</div>
                                        </div>
                                        <div className="img_box">
                                            <img src={Car1} alt="" />
                                        </div>
                                        <div className="btn_box">
                                            <div className="design" onClick={() => Navigate("/design?id=v")}>Design yours</div>
                                            {/* <div className="model">Compare Model</div> */}
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="slider_box">
                                        <div className="title_box">
                                            <div className="new">Now Delivering</div>
                                            <div className="name">Flux Freedom</div>
                                        </div>
                                        <div className="img_box">
                                            <img src={Car1} alt="" />
                                        </div>
                                        <div className="btn_box">
                                            <div className="design" onClick={() => Navigate("/design?id=f")}>Design yours</div>
                                            {/* <div className="model">Compare Model</div> */}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </>
                    }
                </Swiper>
            </div>
        </>
    )
}

const CarsSliderHorizontal = () => {
    const Navigate = useNavigate()

    let carsData = useSelector((state) => state.CarsData)

    return (
        <>
            <div className="carslider_container" style={{ height: "70vh" }}>
                <Swiper loop={true} navigation={true} modules={[Navigation]} autoplay={{ delay: 2500, disableOnInteraction: false, }} className="mySwiper">
                    {
                        carsData && carsData.length >= 1 ?
                            carsData.map((data) => {
                                return (
                                    <>
                                        <SwiperSlide>
                                            <div className="slider_box">
                                                <div className="title_box">
                                                    <div className="new">Now Delivering</div>
                                                    <div className="name">{data.name}</div>
                                                </div>
                                                <div className="img_box">
                                                    <img style={{ width: "70%" }} src={data.paintsWheels[0].carImg} alt="" />
                                                </div>
                                                <div className="btn_box">
                                                    <div className="design" onClick={() => Navigate(`/design?id=${data._id}`)}>Design yours</div>
                                                    <div className="model" onClick={() => Navigate(`/`)}>Cancle</div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    </>
                                )
                            })
                            :
                            <>
                                <SwiperSlide>
                                    <div className="slider_box">
                                        <div className="title_box">
                                            <div className="new">Now Delivering</div>
                                            <div className="name">Flux Village</div>
                                        </div>
                                        <div className="img_box">
                                            <img style={{ width: "70%" }} src={Car1} alt="" />
                                        </div>
                                        <div className="btn_box">
                                            <div className="design" onClick={() => Navigate("/design?id=v")}>Design yours</div>
                                            <div className="model" onClick={() => Navigate(`/`)}>Cancle</div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                                <SwiperSlide>
                                    <div className="slider_box">
                                        <div className="title_box">
                                            <div className="new">Now Delivering</div>
                                            <div className="name">Flux Freedom</div>
                                        </div>
                                        <div className="img_box">
                                            <img style={{ width: "70%" }} src={Car1} alt="" />
                                        </div>
                                        <div className="btn_box">
                                            <div className="design" onClick={() => Navigate("/design?id=f")}>Design yours</div>
                                            <div className="model" onClick={() => Navigate(`/`)}>Cancle</div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            </>
                    }
                    <SwiperSlide>
                        <div className="slider_box">
                            <div className="title_box">
                                <div className="new">Now Delivering</div>
                                <div className="name">Flux Village</div>
                            </div>
                            <div className="img_box">
                                <img style={{ width: "70%" }} src={Car1} alt="" />
                            </div>
                            <div className="btn_box">
                                <div className="design" onClick={() => Navigate("/design?id=v")}>Design yours</div>
                                {/* <div className="model">Compare Model</div> */}
                            </div>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide>
                        <div className="slider_box">
                            <div className="title_box">
                                <div className="new">Now Delivering</div>
                                <div className="name">Flux Freedom</div>
                            </div>
                            <div className="img_box">
                                <img style={{ width: "70%" }} src={Car1} alt="" />
                            </div>
                            <div className="btn_box">
                                <div className="design" onClick={() => Navigate("/design?id=f")}>Design yours</div>
                                {/* <div className="model">Compare Model</div> */}
                            </div>
                        </div>
                    </SwiperSlide>
                </Swiper>
            </div>
        </>
    )
}

export default CarsSlider
export { CarsSliderHorizontal }